import $ from 'jquery';

// Scripts to handle basket methods ...

$(function() {

    window.initAddBasketItem();

    window.initDeleteBasketItem();

    window.initUpdateBasketItem();

});


//function initAddBasketItem() {
window.initAddBasketItem = function () {

    //console.log('initAddBasketItem');

    $('.add-to-basket').unbind('click');
    $('.add-to-basket').on('click', function(e) {

        //console.log('add-item click');

        let productVariantId = $(this).attr('data-product-variant-id');
        let itemQuantity = $(this).attr('data-item-quantity');

        return axios.post('/manager/ecommerce/basket/add-item', {
            productVariantId: productVariantId,
            itemQuantity: itemQuantity
        }).then(function (response) {
            //console.log(response);
            updateHeaderBasketItemCount(response);
        })
        .catch(function (error) {
            console.log(error);
        });

    });

}


//function initDeleteBasketItem() {
window.initDeleteBasketItem = function () {

    //console.log('initDeleteBasketItem');

    $('.basket-item-delete').unbind('click');
    $('.basket-item-delete').on('click', function(e) {

        //console.log('basket-item-delete click');

        let basketItemId = $(this).attr('data-basket-item-id');
        let price = $(this).attr('data-basket-item-price');

        return axios.post('/manager/ecommerce/basket/delete-item', {
            basketItemId: basketItemId,
            price: price,
            quantity: 0,
            incGA4: true
        }).then(function (response) {

            //console.log(response);

            let basketDetails = null;
            if (response.data) {
                if (response.data.basketDetails) {
                    basketDetails = response.data.basketDetails;
                } else {
                    basketDetails = response.data;
                }
            }

            //console.log(basketDetails);

            if (basketDetails) {
                updateBasket(basketItemId, basketDetails);
            }

            if (response.data.ga4 && (response.data.ga4 != '')) {
                // Clear the dataLayer ecommerce object
                dataLayer.push({ecommerce: null});
                // Add the new ga4 data
                dataLayer.push(response.data.ga4);
            }

        })
            .catch(function (error) {
                console.log(error);
            });

    });

}


//function initUpdateBasketItem() {
window.initUpdateBasketItem = function () {

    //console.log('initUpdateBasketItem');

    $('.basket-item-quantity').unbind('change');
    $('.basket-item-quantity').on('change', function(e) {

        //console.log('basket-item-update blur');

        updateBasketItem($(this), true);

    });

}

window.updateBasketItem = function (el, incGA4 = false) {

    //console.log(incGA4);
    //console.log('updateBasketItem');

    let basketItemId = el.attr('data-basket-item-id');
    let quantity = el.val();
    let price = el.attr('data-basket-item-price');

    let itemWrapper = $(".basket-item-wrapper[data-item-id='" + basketItemId + "']");

    itemWrapper.each(function() {
        $(this).find('.basket-item-quantity').val(quantity);
        $(this).find('.basket-loader').removeClass('hidden');
    });

    $('.modify-quantity').each(function() {
        $(this).prop('disabled', true);
    });

    $('.basket__totals .basket-loader').removeClass('hidden');

    return axios.post('/manager/ecommerce/basket/update-item', {
        basketItemId: basketItemId,
        quantity: quantity,
        price: price,
        incGA4: incGA4
    }).then(function (response) {

        //console.log('This is the real code');
        //console.log(response);

        let basketDetails = null;
        if (response.data) {
            if (response.data.basketDetails) {
                basketDetails = response.data.basketDetails;
            } else {
                basketDetails = response.data;
            }
        }

        //console.log(basketDetails);

        if (basketDetails) {
            updateBasket(basketItemId, basketDetails);
        }

        $('.modify-quantity').each(function() {
            $(this).prop('disabled', false);
        });

        if (response.data.ga4 && (response.data.ga4 != '')) {
            // Clear the dataLayer ecommerce object
            dataLayer.push({ecommerce: null});
            // Add the new ga4 data
            dataLayer.push(response.data.ga4);
        }

    }).catch(function (error) {
        console.log(error);
    });
}


function updateBasket(basketItemId, basketDetails) {

    //console.log('updateBasket');
    //console.log(basketDetails);

    updateHeaderBasketItemCount(basketDetails);

    if (basketDetails.items.length === 0) {
        // reload the page
        location.reload();
        // Can't remember whether I commented this out for debugging or to fix something ...
        //console.log('location.reload() commented out');
        return false;
    }

    // Run a client specific routine to update the basket display if it exists
    if (typeof customUpdateBasket === 'function') {
        //console.log('customUpdateBasket defined');
        customUpdateBasket(basketDetails);
        return;
    }

    let basketItemIds = [];

    // Get an array of row ids
    $('tr.basket-item-wrapper[data-item-id]').each(function() {
        // Note the + to force the id to an integer rather than a string,
        // otherwise the removal sequence doesn't find a match
        basketItemIds.push(+$(this).attr('data-item-id'));
    });

    basketDetails.items.forEach(function(item) {

        let idx = basketItemIds.indexOf(item.item_id);
        if (idx > -1) {
            basketItemIds.splice(idx, 1);
        }
    });

    let currencySymbol = basketDetails.currency_symbol;

    updateBasketItemTotal(basketItemId, currencySymbol, basketDetails.items);
    updateBasketTotals(currencySymbol, basketDetails)

    $('.basket-item-wrapper .basket-loader').addClass('hidden');

    if (basketItemIds.length) {
        basketItemIds.forEach(function(itemId) {
            $('.basket-item-wrapper[data-item-id=' + itemId + ']').remove();
        });
    }

}

function updateBasketItemTotal(basketItemId, currencySymbol, items) {

    //console.log('updateBasketItemTotal');

    let item = '';

    items.forEach(function(row) {
        //console.log(row.item_id);
        if(row.item_id === +basketItemId) {
            item = row;
        }
    });

    let id = item.item_id;

    let itemWrappers = $(".basket-item-wrapper[data-item-id='" + id + "']");

    $(itemWrappers).each(function() {
        $(this).find('.basket-item-total').text(currencySymbol + item.item_gross);
    });

}

function updateBasketTotals(currencySymbol, basketDetails) {

    //console.log('updateBasketTotals');

    $('#basket-item-total').text(currencySymbol + basketDetails.item_total);

    $('#basket-discount').text(currencySymbol + basketDetails.discount);

    if (basketDetails.discount_num > 0) {
        $('#basket-discount').closest('.basket__totals__row').removeClass('hidden');
    } else {
        $('#basket-discount').closest('.basket__totals__row').addClass('hidden');
    }

    $('#basket-shipping').text(currencySymbol + basketDetails.shipping_gross);

    if (basketDetails.shipping_gross_num > 0) {
        $('#basket-shipping').closest('.basket__totals__row').removeClass('hidden');
    } else {
        $('#basket-shipping').closest('.basket__totals__row').addClass('hidden');
    }

    $('#basket-net-tax').text(currencySymbol + basketDetails.net_tax);

    $('#basket-net-total').text(currencySymbol + basketDetails.net_total);

    $('.basket__totals .basket-loader').addClass('hidden');
}


function updateHeaderBasketItemCount(basketDetails) {

    //console.log('updateHeaderBasketItemCount');

    // Find the basket count li in the header and update with the new number, or remove altogether if 0
    let basketItemCount = basketDetails.basket_item_count;

    let $basketItemCountElement = $('#basket-count');

    if (basketItemCount) {
        $basketItemCountElement.html(basketItemCount);
    } else {
        $basketItemCountElement.html('');
    }

}
